import { Deck } from "../models/Deck"
import { stringify } from 'csv-stringify/browser/esm/sync';
import { Card } from "../models/Card";
import { ProductRepository } from "./ProductRepository";
import { saveAs } from "file-saver";

export class TextDeckWriter {

    private deck: Deck;

    constructor(deck: Deck) {
        this.deck = deck;
    }

    public generateText() {

        const strArray = this.deck.favoriteCards.map(card => this.convertToArray(card, true, 1));

        this.deck.normalCards.forEach(stackCard => {
            strArray.push(this.convertToArray(stackCard.card, false, stackCard.count));
        });

        return stringify(
            strArray
        );
    }

    public downloadTextDeck(name: string) {
        const text = this.generateText();
        const blob = new Blob([text], { type: 'text/plain' })
        saveAs(blob, name + '.txt');
    }

    private convertToArray(card: Card, isFavorite: boolean, length?: number) {
        if (isFavorite && (length !== undefined && length >= 2)) {
            throw new Error('Not allowed multiple favorite card.');
        }

        return [
            `${isFavorite ? '推' : (length ?? 1)}`,
            ProductRepository.getProduct(card.cardProductId).title,
            card.cardNo,
            card.cardName
        ];
    }

}